import { useEffect, useState, useSyncExternalStore } from "react";
import { outboxSnapshot, subscribeOutbox, type OutboxEntry } from "../lib/outbox";

// A normal send takes well under this, so the hint doesn't flash every time.
const SHOW_AFTER_MS = 1500;

/** Posts and comments on this device that the server hasn't confirmed yet. */
export function useOutbox(): OutboxEntry[] {
  return useSyncExternalStore(subscribeOutbox, outboxSnapshot);
}

/** Whether this post or comment is still on its way to the server. */
export function useStillSending(path: string): boolean {
  const queuedAt = useSyncExternalStore(
    subscribeOutbox,
    () => outboxSnapshot().find((entry) => entry.path === path)?.at ?? 0,
  );
  const [, rerender] = useState(0);
  const age = queuedAt ? Date.now() - queuedAt : 0;
  useEffect(() => {
    if (!queuedAt || age >= SHOW_AFTER_MS) return;
    const timer = setTimeout(() => rerender((n) => n + 1), SHOW_AFTER_MS - age);
    return () => clearTimeout(timer);
  }, [queuedAt, age]);
  return !!queuedAt && age >= SHOW_AFTER_MS;
}
